import React, { ReactNode } from "react";
import LoadingView from "../views/LoadingView";
import { useParams } from "react-router-dom";
import { useGetFacilityTimeQuery } from "../slices/facilityTimeApi";

interface Props {
  children: ReactNode;
}

/**
 * Preload facility time data for timezone-aware calculations
 * Use RTK query `isLoading` to track initial load of the API call.
 */
export default function RequireFacilityTime({ children }: Props) {
  const { jobNumber } = useParams();
  const { isLoading } = useGetFacilityTimeQuery(
    { jobNumber: jobNumber! },
    { skip: !jobNumber }
  );

  if (isLoading) {
    return <LoadingView />;
  }

  return children;
}
